import styled from "styled-components";

const NavButton = ({ direction, visible, onClick }) => {
  return (
    <Wrapper direction={direction} visible={visible}>
      <Button onClick={onClick} visible={visible}>
        {direction === "left" ? "‹" : "›"}
      </Button>
    </Wrapper>
  );
};

export default NavButton;

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  ${({ direction }) => (direction === "left" ? "left: 10px;" : "right: 10px;")}
  transform: translate(0, -50%);
  height: 290px;
  background: black;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);

  ${({ visible, direction }) =>
    visible &&
    `transform: translate(${direction === "left" ? "40px" : "-40px"}, -50%);`}

  @media (max-width: 968px) {
    ${({ direction }) => (direction === "left" ? "left: -20px;" : "right: -20px;")}
    height: 185px;
  }

  @media (max-width: 568px) {
    ${({ direction }) => (direction === "left" ? "left: -50px;" : "right: -50px;")}
    height: 185px;
  }
`;

const Button = styled.button`
  background: #efac00;
  color: #0a0a0a;
  font-size: 24px;
  font-weight: 900;
  border: none;
  padding: 28px 8px;
  border-radius: 6px;
  cursor: pointer;
  opacity: 0;
  transition: background 0.3s ease, opacity 0.4s ease;

  ${({ visible }) => visible && "opacity: 1;"}

  &:hover {
    background: #fdc537;
  }
`;
